import React, { useMemo } from "react";
import { Box, Grid, useTheme } from "@material-ui/core";
import { LastBill } from "./components/LastBill";
import { PaymentDetails } from "./components/PaymentDetails";
import { useAccountFinancials } from "./hooks/useAccountFinancials";
import { useParams } from "react-router-dom";
import { AlertBlock } from "../../components/AlertBlock";
import { AccountBalance } from "./components/AccountBalance";
import { useAccountTickets } from "./hooks/useAccountTickets";
import { Tickets } from "./components/Tickets";

/**
 * Detailed summary of the financials of an account and active tickets
 */
export const FinancialSummary: React.FC = () => {
  const { accountNumber } = useParams();
  const { error: financialError } = useAccountFinancials(accountNumber!);
  const { error: ticketError } = useAccountTickets(
    accountNumber!,
    "Open,Error",
  );
  const theme = useTheme();
  const props = useMemo(
    () => ({
      flex: "0 1 25%",
      whiteSpace: "nowrap",
      paddingRight: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
    }),
    [theme],
  );

  const error = financialError || ticketError;
  return error ? (
    <AlertBlock variant="error" messages={[(error as Error)?.message]} />
  ) : (
    <Box maxWidth="900px" clone>
      <Grid container alignItems="flex-start">
        <AccountBalance {...props} />
        <LastBill {...props} />
        <PaymentDetails {...props} />
        <Tickets {...props} />
      </Grid>
    </Box>
  );
};
